export function applyAxiosRedirectListener(axios) {
  axios.interceptors.response.use((response) => response, (error) => {
    const response = error.response;
    if (response && response.status === 403 && response.data && response.data.location) {
      window.location = error.response.data.location
    }
    return Promise.reject(error);
  })
}
